import { render } from "./ExportCriticalCases.vue?vue&type=template&id=1fe5c4c4"
import script from "./ExportCriticalCases.vue?vue&type=script&lang=js"
export * from "./ExportCriticalCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/ExportCriticalCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1fe5c4c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1fe5c4c4', __exports__)) {
    console.log('reload')
    api.reload('1fe5c4c4', __exports__)
  }
  
  module.hot.accept("./ExportCriticalCases.vue?vue&type=template&id=1fe5c4c4", () => {
    console.log('re-render')
    api.rerender('1fe5c4c4', render)
  })

}


export default __exports__